export const CONSTRUCTOR_EVENTS = {
  ADD_BLOCK: "add_block",
  EDIT_STRUCTURE: "pf_edit_structure",
  EDIT_STYLE: "pf_edit_style",
  APPLY_CUSTOM_STYLE: "pf_apply_custom_style",
  CONFIGURE_BUTTON: "pf_configure_button",
  ENABLE_ADVANCED_MODE: "pf_enable_advanced_mode",
  EDIT_CSS: "pf_edit_css",
  CREATE_PAGE: "create_page",
  CREATE_SUBPAGE: "pf_create_subpage",
  ADD_MEDIA_BLOCK: "pf_add_media_block",
  EDIT_RESPONSIVE: "pf_edit_responsive",
  EDIT_ON_MOBILE: "pf_edit_on_mobile",
  CONFIGURE_SEO: "pf_configure_seo",
  TOGGLE_INDEXING: "pf_toggle_indexing",
  CUSTOMIZE_URL: "pf_customize_url",
  CONNECT_CUSTOM_DOMAIN: "pf_connect_custom_domain",
  SHARE_PAGE: "pf_share_page",
  DOWNLOAD_QR: "download_qr",
  INSTANT_UPDATE_CONTENT: "pf_instant_update_content",
  DISABLE_BRANDING: "pf_disable_branding",
  DISABLE_ADS: "pf_disable_ads",
  PREVIEW_PAGE: "pf_preview_page",
  CREATE_PROJECT: "create_project",
  MANAGE_PAGES: "pf_manage_pages",
  DUPLICATE_PAGE: "pf_duplicate_page",
  PUBLISH_PAGE: "publish_page",
  SHARE_ACCESS: "pf_share_access",
  RESTRICT_PAGE_ACCESS: "pf_restrict_page_access",
  VIEW_PAGE_ANALYTICS: "pf_view_page_analytics",
  BEGIN_CHECKOUT: "begin_checkout",
} as const;

const ALLOWED_EVENT_PARAMS = new Set([
  "source_block",
  "platform",
  "method",
  "plan",
  "plan_period",
  "template_id",
  "page_id",
  "project_id",
  "user_id",
  "utm_source",
  "geo",
  "value",
  "currency",
  "transaction_id",
  "feature_code",
  "feature_group",
]);

type GtagEventParams = Record<string, unknown>;

function normalizeParams(params: GtagEventParams): GtagEventParams {
  return Object.fromEntries(
    Object.entries({
      platform: window.matchMedia("(max-width: 767px)").matches
        ? "mobile"
        : "desktop",
      ...params,
    }).filter(([key, value]) => ALLOWED_EVENT_PARAMS.has(key) && value != null)
  );
}

export function gtagEvent(event: string, params: GtagEventParams = {}): void {
  if (typeof window.gtag !== "function") {
    console.warn("gtag is not available");
    return;
  }

  window.gtag("event", event, {
    ...normalizeParams(params),
    transport_type: "beacon",
  });
}

export function gtagEventAndNavigate({
  event,
  params = {},
  targetUrl,
  timeout = 200,
}: {
  event: string;
  params?: GtagEventParams;
  targetUrl?: string;
  timeout?: number;
}): Promise<void> {
  return new Promise((resolve) => {
    if (typeof window.gtag !== "function") {
      console.warn("gtag is not available");

      if (targetUrl) {
        window.location.href = targetUrl;
      }

      resolve();
      return;
    }

    let navigated = false;

    const navigate = () => {
      if (navigated || !targetUrl) return;
      navigated = true;
      window.location.href = targetUrl;
      resolve();
    };

    window.gtag("event", event, {
      ...normalizeParams(params),
      transport_type: "beacon",
      event_callback: navigate,
    });

    setTimeout(() => {
      if (!navigated && targetUrl) {
        navigate();
      } else if (!targetUrl) {
        resolve();
      }
    }, timeout);
  });
}
